import React, { PropsWithChildren, useEffect, useRef, useState } from 'react'
import './index.scss'

interface RadioSelectionTabProps {
    id: string
    name: string
    subTitle?: string
    onClick: () => void
    defaultChecked?: boolean
    forceChecked?: boolean
}

const RadioSelectionTab = ({
    id,
    name,
    subTitle,
    onClick,
    defaultChecked = false,
    forceChecked = false,
    children,
}: PropsWithChildren<RadioSelectionTabProps>) => {
    const searchRadioRef = useRef<HTMLInputElement>(null)

    const [checked, setChecked] = useState(defaultChecked)

    useEffect(() => {
        setChecked(forceChecked)
    }, [forceChecked])

    return (
        <div>
            <input
                ref={searchRadioRef}
                id={id}
                name="search-radio"
                type="radio"
                value="Search"
                onClick={() => {
                    onClick()
                }}
                checked={checked}
                readOnly
            />

            <label className="radio-selection-heading" htmlFor={id} onClick={() => searchRadioRef.current?.click()}>
                {name}
            </label>

            {checked && <div className="sub-title">{subTitle}</div>}

            {children}
        </div>
    )
}

export default RadioSelectionTab
